import { listDataDic } from './servers';
// 处理登录结构  设置为平铺
export function orgUserHandle(data) {
	if (data && data.length > 0) {
		let userOrgs = [];
		data.forEach((item) => {
			if (item.orgInfoList && item.orgInfoList.length > 0) {
				item.orgInfoList.forEach((element) => {
					element['orgTypeCode'] = item.orgTypeCode;
					element['orgTypeName'] = item.orgTypeName;
					userOrgs.push(element);
				});
			}
		});
		return userOrgs;
	}
}
//处理登录结构  设置为级联
export function orgUsertree(data) {
	if (data && data.length > 0) {
		let userOrgs = [];
		userOrgs = data.map((item) => {
			item['orgId'] = item.orgTypeCode;
			item['displayOrgName'] = item.orgTypeName;
			//item['selectable'] = false;
			return item;
		});
		return userOrgs;
	}
}

export async function getListDataDic(code) {
	if (!code) return [];
	let data = [];
	await listDataDic({ dicCategoryCode: code }).then((res) => {
		data = (res.data || []).map((item) => {
			item.label = item.dicName;
			item.value = item.dicCode;
			return item;
		});
	});
	return data;
}
